/**
 * Export
 */
export const baseUrl = process.env.REACT_APP_API_URL.replace('http:', window.location.protocol)
export const nodeApiUrl = process.env.REACT_APP_NODE_API_URL.replace('http:', window.location.protocol)
export const basePriceUrl = process.env.REACT_APP_PRICE_API_URL.replace('http:', window.location.protocol)



// WEBPACK FOOTER //
// ./src/services/api/config.js